import {featureFlags} from '@dms/feature-flags';

/**
 * Feature flag that gates a permission group, by group id.
 *
 * Partial on purpose: almost every group id is absent, so the lookup has to type as
 * `string | undefined` and force callers to handle the miss.
 */
export const featureFlagsByAcl: Partial<Record<string, string>> = {
  VAT_CALCULATION_DEFINITION: featureFlags.ACL_VAT_CALCULATION_DEFINITION,
  VAT_CHECK_TOTALS_DEFINITION: featureFlags.ACL_VAT_CHECK_DEFINITION,
  NEGATIVE_DOCUMENT_CANCELLATION_DEFINITION:
    featureFlags.ACL_NEGATIVE_DOCUMENT_CANCELLATION_DEFINITION,
};
